import GridContainer from '../components/GridContainer'
import React, { useState } from "react"
import Literal from "../literals/Literal"
import { FirestoreService } from '../lib/firestore'
import Header from '../components/Header'
import logoVote from '../assets/images/vote-for-your-weekend.svg'
import { useHistory } from "react-router-dom";

const Home = () => {
  const [teamName, setTeamName] = useState()
  const [error, setError] = useState(false)
  const history = useHistory();
  const errorText = Literal('ERROR_MIN_LENGHT_1')
  const submit = (event) => {
    event.preventDefault()

    if (!teamName || teamName.length <= 1) {
      setError(errorText)
    } else {
      const createTeam = async () => {
        const db = await new FirestoreService()
        db.createTeam(teamName).then((result) => {
          if (result.voteUrl) {
            history.push(result.voteUrl)
          } else if (result.error) {
            setError(result.errorMessage)
          }
        }).catch((error) => console.log(error))
      }
      createTeam()
    }
  }
  return (
    <>
      <Header />
      <GridContainer>
        <div className="flex flex-col col-span-4 md:col-start-5 sm:col-start-2 sm:col-span-2 md:col-span-4">
          <div className="self-center w-full max-w-md px-12 py-6 sm:px-4 md:px-0 lg:px-8">
            <img src={logoVote} alt="VOTE YOUR WEEKEND" className="w-full"/>
          </div>
        </div>
        <div className="col-span-4 col-start-1 pt-2 text-xl leading-tight sm:pt-4 sm:pb-2 md:text-3xl xl:text-4xl md:col-start-2 md:col-span-10">
          <div className="flex flex-wrap items-center justify-center lg:max-w-4xl lg:mx-auto">
            <span className="mr-2 text-center font-secondary">{Literal('HOME_INTRO_1')}</span>
            <span className="mr-2 text-center font-secondary">{Literal('HOME_INTRO_2')}</span>
            <span className="text-center font-secondary">{Literal('HOME_INTRO_3')}</span>
          </div>
        </div>
        <form onSubmit={submit} className="flex flex-col items-center justify-center col-span-4 text-lg md:text-xl lg:text-2xl md:col-start-5">
          <label className="pb-4 text-center">{Literal('HOME_INPUT_LABEL')}</label>
          <input className="w-full h-12 p-2 mb-8 border sm:mb-10 border-button-green rounded-xl" type="text" onChange={event => setTeamName(event.target.value)}></input>
          {error && <p className="w-full h-full mb-4 -mt-6 leading-none sm:-mt-8 sm:mb-10 text-red">{error}</p>}
          <input className="px-16 py-4 text-white rounded-full cursor-pointer font-secondary bg-button-green hover:opacity-80" type="submit" value={Literal('HOME_BUTTON_LABEL')} />
        </form>
      </GridContainer>
    </>
  )
}

export default Home